import {NavigationItem} from "./core/models/navigation-item.model";

export const navigation: NavigationItem[] = [
  {
    text: 'Home',
    icon: 'home',
    path: '/home',
    permissions: null,
    expanded: false,
    items: null
  },
  {
    text: 'Profile',
    icon: 'card',
    path: '/profile',
    permissions: null,
    expanded: false,
    items: null
  },
  {
    text: 'Users',
    icon: 'group',
    path: '/users',
    permissions: ['Users.Access'],
    expanded: false,
    items: null
  },
  {
    text: 'Contractors',
    icon: 'folder',
    path: '/contractors',
    permissions: ['Contractors.Access'],
    expanded: false,
    items: null
  },
  {
    text: 'Orders',
    icon: 'cart',
    path: '/orders',
    permissions: ['Orders.Access'],
    expanded: false,
    items: null
  },
  {
    text: 'Transport',
    icon: 'globe',
    path: null,
    permissions: ['TransportOrders.Access'],
    expanded: true,
    items: [{
      text: 'Transport orders',
      icon: null,
      path: '/transport-orders',
      permissions: ['TransportOrders.Access'],
      expanded: false,
      items: null
    }, {
      text: 'Route planning',
      icon: null,
      path: '/transport-orders/route-planning',
      permissions: ['TransportOrders.RoutePlan'],
      expanded: false,
      items: null
    }, {
        text: 'Pickup map',
        icon: null,
        path: '/transport-orders/pickup-map',
        permissions: ['TransportOrders.Map'],
        expanded: false,
        items: null
      }]
  },
  {
    text: 'Vehicle pickups at square',
    icon: 'car',
    path: '/square-vehicle-pickups',
    permissions: ['SquareVehiclePickups.Access'],
    expanded: false,
    items: null
  },
];
